module.exports = __webpack_public_path__ + "img/vertical-stairs.b7cb7063.png";